import { batch } from "react-redux";
import { requestGridData as requestAnalyticsData } from "state/analytics/actions";
import { requestGridData as requestBookAnalyticsData } from "state/bookAnalytics/actions";
import { requestGridData as requestBetasGridData } from "state/betas/actions";
import { requestGridData as requestScenarioAnalysisData } from "state/scenarioAnalysis/actions";
import {
  requestBaseGridData,
  requestBaseSbsGridData,
} from "state/grid/actions";
import { requestGridData as requestSecurityAttributesGridData } from "state/securityAttributes/actions";
import { requestGridData as requestTrackingErrorGridData } from "state/trackingError/actions";
import { requestGridData as requestFaaData } from "state/factorAttribution/actions";
import { requestGridData as requestIssueCountData } from "state/issueCount/actions";
import { requestGridData as requestIssuerCountData } from "state/issuerCount/actions";
import { requestGridData as requestTracePricingData } from "state/traceAnalytics/actions";
import { requestGridData as requestRatingsData } from "state/ratings/actions";
import { requestGridData as requestScan2Data } from "state/scan2/actions";

export const TOGGLE_DRAWER = "app/TOGGLE_DRAWER";
export const toggleDrawer = (opts = {}) => ({
  type: TOGGLE_DRAWER,
  override: opts.override,
});

export const SET_APP_TITLE = "app/SET_APP_TITLE";
export const setAppTitle = (appTitle) => ({
  type: SET_APP_TITLE,
  appTitle,
});
export const SET_APP_NAME_TITLE = "app/SET_APP_NAME_TITLE";
export const setAppNameTitle = (appNameTitle) => ({
  type: SET_APP_NAME_TITLE,
  appNameTitle,
});

export const SET_LOAD_DATA_ON_LAUNCH = "app/LOAD_DATA_ON_LAUNCH";
export const setLoadDataOnLaunch = (value) => ({
  type: SET_LOAD_DATA_ON_LAUNCH,
  payload: value,
});

export const SET_APP_DECIMAL = "app/SET_APP_DECIMAL";
export const setAppDecimal = (appDecimal) => ({
  type: SET_APP_DECIMAL,
  appDecimal,
});

export const SET_DEFAULT_EXPANSION = "app/SET_DEFAULT_EXPANSION";
export const setDefaultExpansion = (defaultExpansion) => ({
  type: SET_DEFAULT_EXPANSION,
  defaultExpansion,
});

export const SET_BANDED_ROWS = "app/SET_BANDED_ROWS";
export const setBandedRows = (bandedRows) => ({
  type: SET_BANDED_ROWS,
  bandedRows,
});

export const SET_GRID_LEVEL_LABELS = "app/SET_GRID_LEVEL_LABELS";
export const setGridLevelLabels = (gridLevelLabels) => ({
  type: SET_GRID_LEVEL_LABELS,
  gridLevelLabels,
});

export const SET_SHOW_GRID_LEVEL_COUNT = "app/SET_SHOW_GRID_LEVEL_COUNT";
export const setShowGridLevelCount = (showGridLevelCount) => ({
  type: SET_SHOW_GRID_LEVEL_COUNT,
  showGridLevelCount,
});

export const SET_GRID_VERTICAL_LINES = "app/SET_GRID_VERTICAL_LINES";
export const setGridVerticalLines = (gridVerticalLines) => ({
  type: SET_GRID_VERTICAL_LINES,
  gridVerticalLines,
});

export const SET_GRID_FONT_SIZE = "app/SET_GRID_FONT_SIZE";
export const setGridFontSize = (gridFontSize) => ({
  type: SET_GRID_FONT_SIZE,
  gridFontSize,
});

export const SET_GRID_ROW_HEIGHT = "app/SET_GRID_ROW_HEIGHT";
export const setGridRowHeight = (gridRowHeight) => ({
  type: SET_GRID_ROW_HEIGHT,
  gridRowHeight,
});

export const SET_GRID_HEADER_HEIGHT = "app/SET_GRID_HEADER_HEIGHT";
export const setGridHeaderHeight = (value) => ({
  type: SET_GRID_HEADER_HEIGHT,
  gridHeaderHeight: value,
});

export const SET_HIDE_GRID_SIDE_BAR = "app/SET_HIDE_GRID_SIDE_BAR";
export const setHideGridSideBar = (value) => ({
  type: SET_HIDE_GRID_SIDE_BAR,
  value,
});

export const SET_LISTEN_SCENARIO_APP_TALK = "app/SET_LISTEN_SCENARIO_APP_TALK";
export const setListenScenarioAppTalk = (value) => ({
  type: SET_LISTEN_SCENARIO_APP_TALK,
  value,
});

export const startRequests = () => {
  return async (dispatch) => {
    batch(() => {
      dispatch(requestBaseGridData());
      dispatch(requestBaseSbsGridData());
      dispatch(requestAnalyticsData());
      dispatch(requestBookAnalyticsData());
      dispatch(requestBetasGridData());
      dispatch(requestScenarioAnalysisData());
      dispatch(requestFaaData());
      dispatch(requestIssueCountData());
      dispatch(requestIssuerCountData());
      dispatch(requestRatingsData());
      dispatch(requestSecurityAttributesGridData());
      dispatch(requestTracePricingData());
      dispatch(requestTrackingErrorGridData());
      dispatch(requestScan2Data());
    });
  };
};
